import React from "react";

type Props = {};

const GenerateQR = (props: Props) => {
  return <div>GenerateQR</div>;
};

export default GenerateQR;
